import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { SelectionModel } from "@angular/cdk/collections";
import { ActivatedRoute } from "@angular/router";
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ConduiteService } from "../../../../core/apps/conduite.service";
import { DynamicCrudConfig } from "./dynamic-crud.config";
import { DynamicCrudDialogComponent } from "./dynamic-crud-dialog/dynamic-crud-dialog.component";

interface DynamicCrudItem {
	id: string;
	libelle: string;
}

@Component({
	selector: "kt-dynamic-crud",
	templateUrl: "./dynamic-crud.component.html",
	styleUrls: ["./dynamic-crud.component.scss"],
})
export class DynamicCrudComponent implements OnInit, OnDestroy {
	displayedColumns = ["select", "ID", "Libelle", "actions"];
	selection = new SelectionModel<DynamicCrudItem>(false, []);
	config: DynamicCrudConfig;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	private destroy$ = new Subject<void>();
	dataSource: MatTableDataSource<DynamicCrudItem> = new MatTableDataSource([]);

	constructor(
		private route: ActivatedRoute,
		private conduiteService: ConduiteService,
		public dialog: MatDialog,
	) {}

	ngOnInit() {
		this.route.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
			this.config = data.dynamicCrud;
			this.loadData();
		});
	}

	private loadData() {
		this.selection.clear();
		this.dataSource = new MatTableDataSource([]);
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;

		this.conduiteService
			.getLibelleList(this.config.collection)
			.pipe(takeUntil(this.destroy$))
			.subscribe((actions) => {
				this.dataSource.data = actions.map((a) => ({
					...(a.payload.doc.data() as DynamicCrudItem),
					id: a.payload.doc.id,
				}));
			});
	}

	applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();

		if (this.dataSource.paginator) {
			this.dataSource.paginator.firstPage();
		}
	}

	isAllSelected() {
		return this.selection.selected.length === this.dataSource.data.length;
	}

	masterToggle() {
		this.isAllSelected()
			? this.selection.clear()
			: this.dataSource.data.forEach((row) => this.selection.select(row));
	}

	openDialogParcelle() {
		this.openDialog({ list: "add" });
	}

	modifierDialog(item: DynamicCrudItem) {
		this.openDialog({
			id: item.id,
			libelle: item.libelle,
			list: "update",
		});
	}

	deleteDialog(item: DynamicCrudItem) {
		this.openDialog({
			id: item.id,
			list: "delete",
		});
	}

	private openDialog(data: any) {
		this.dialog.open(DynamicCrudDialogComponent, {
			width: "600px",
			data: {
				...data,
				config: this.config,
				existing: this.dataSource.data.map(x => x.libelle),
			},
		});
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
